import React from 'react';

import image from 'src/assets/invoicing/analytics.svg';

import MHButton from '../MHButton';

export enum InvoicingPageFormSubmittedTestID {
  InvoicingPageFormSubmitted = 'invoicing-page-form-submitted',
}

interface Props {
  onPress: () => void;
}

export const InvoicingPageFormSubmitted: React.FC<Props> = ({ onPress }) => (
  <div
    data-testid={InvoicingPageFormSubmittedTestID.InvoicingPageFormSubmitted}
    className="text-center mt-24"
  >
    <img src={image} alt="success" className="mx-auto" />

    <h3 className="mt-8 text-gray-1000 font-extrabold text-2xl">Session reported successfully!</h3>
    <p className="mt-4 font-medium text-gray-600 text-sm">Questions or feedback? Please email:</p>
    <a
      className="leading-6 font-bold text-blue-200 text-sm cursor-pointer hover:underline mb-4 block"
      href="mailto:provider@joinmodernhealth.com"
    >
      provider@joinmodernhealth.com
    </a>

    <MHButton onClick={onPress} className="w-48">
      Report another session
    </MHButton>
  </div>
);
